<template>
    <div class="layout-import-popup">
        <div class="layout-ipp-content">
            <p class="layout-ipp-bold">恭喜授权成功，已经开始导入，大概需要3-5分钟。</p>
            <p class="layout-ipp-normal">长按关注公众号，导入完成后将通过公众号通知。</p>
            <p class="layout-ipp-center">
                <img class="layout-ipp-img" v-bind:src="qrCode" alt="">
            </p>
        </div>
        <div class="layout-ipp-close">
            <i class="iconfont icon-close layout-ipp-icon" @click="clickClose"></i>
        </div>
    </div>
</template>


<script>
export default {
    name: 'ImportPopup',
    data(){
        return {
            qrCode: require('../../assets/images/qrcode.png')
        }
    },
    components: {},
    methods:{
        clickClose() {
            this.$store.state.import.showPopup = false;
        }
    }
}
</script>